function _(n,e,t){var i=n(113),r=function(n){function e(e){return n.call(this,e)||this}return i.__extends(e,n),e}(n(166).Model);t.Ticker=r,r.__name__="Ticker"}
//# sourceMappingURL=ticker.min.js.map